"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactContentLoader = require("react-content-loader");

var _reactContentLoader2 = _interopRequireDefault(_reactContentLoader);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports["default"] = function (props) {
  if (props.slidesAmount === 1) {
    return _react2["default"].createElement("div", {
      className: "w-100 aspect-ratio aspect-ratio--1x1"
    }, _react2["default"].createElement(_reactContentLoader2["default"], {
      style: {
        position: 'absolute',
        width: '100%',
        height: '100%'
      },
      height: "100%",
      width: "100%"
    }, _react2["default"].createElement("rect", {
      width: "100%",
      height: "100%"
    })));
  }

  return _react2["default"].createElement("div", {
    className: "w-100 aspect-ratio aspect-ratio--1x1"
  }, _react2["default"].createElement(_reactContentLoader2["default"], {
    style: {
      position: 'absolute',
      width: '100%',
      height: '100%'
    },
    height: "100%",
    width: "100%"
  }, _react2["default"].createElement("rect", {
    className: "dn db-ns",
    width: "18%",
    height: "18%"
  }), _react2["default"].createElement("rect", {
    className: "dn db-ns",
    width: "18%",
    height: "18%",
    y: "20%"
  }), _react2["default"].createElement("rect", {
    className: "dn db-ns",
    width: "18%",
    height: "18%",
    y: "40%"
  }), _react2["default"].createElement("rect", {
    className: "dn db-ns",
    width: "18%",
    height: "18%",
    y: "60%"
  }), _react2["default"].createElement("rect", {
    className: "dn db-ns",
    width: "89%",
    height: "89%",
    x: "20%"
  }), _react2["default"].createElement("rect", {
    className: "db dn-ns",
    width: "100%",
    height: "100%"
  })));
};